import { useEffect, useState } from 'react';
import apiServices from '../../services/service';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Dropdown } from 'react-bootstrap';
import Loader from '../../shared/component/Loader';
import permission from '../../assets/img/add-permission.svg';
function ActionPermissionList() {
  const intialJson = {
    permissionId: '',
    permissionValue: '',
    permissionDisplayName: '',
    permissionSetId: '',
    permissionGroupId: '',
    permissionGroupDisplayName: '',
    module: '',
  };
  const [permissionList, setPermissionList] = useState();
  const [show, setShow] = useState(false);
  const [isAddPermission, setIsAddPermission] = useState(false);

  const [formData, setFormData] = useState(intialJson);
  const [permissionGroupListSelected, setPermissionGroupListSelected] = useState();
  const [permissionModuleList, setPermissionModuleList] = useState();
  const [unListedPermissions, setUnListedPermissions] = useState();

  const [isGetModuleList, setIsGetModuleList] = useState(true);
  const [isGetPermissionSetList, setIsGetPermissionSetList] = useState(true);
  const [permissionSetList, setPermissionSetList] = useState();

  const [loading, setLoading] = useState(false);
  const [isGetPermissionList, setIsGetPermissionList] = useState(true);
  const [isGetUnListedPermissions, setIsUnListedPermissions] = useState(true);
  const [isPermissionListRefreshed, setIsPermissionListRefreshed] = useState(false);
  const [isUnlistedPermissionListRefreshed, setIsUnlistedPermissionListRefreshed] = useState(false);

  const handleClose = () => {
    setShow(false);
    setIsAddPermission(false); // Reset to default state when closing the popup
    setFormData({});
  };

  const handleShowAdd = () => {
    setShow(true);
    setIsAddPermission(true); // Set to true when adding a new permission
    setFormData({
      ...intialJson,
      type: 'add',
    });
  };
  // Method to handle dropdown change event
  const handlePermissionChange = (selectedId, name, DisplayName) => {
    if (name === 'permissionName') {
      setFormData({
        ...formData,
        permissionId: ' ', // Update selected permission ID in formData
        permissionDisplayName: DisplayName,
        permissionValue: DisplayName,
      });
    } else if (name === 'permissionModule') {
      setFormData({
        ...formData,
        module: DisplayName,
        ModuleId: selectedId,
        permissionGroupId: '',
        permissionGroupDisplayName: '',
        permissionSetId: '',
      });
    } else if (name === 'permissionGroupName') {
      setFormData({
        ...formData,
        permissionGroupId: selectedId, // Update selected permission ID in formData
        permissionGroupDisplayName: DisplayName,
        permissionSetId: '',
      });
      const filteredArray = permissionSetList.filter((obj) => obj.permissionGroupId === selectedId);
    } else if (name === 'permissionSet') {
      setFormData({
        ...formData,
        permissionSetId: selectedId,
        permissionSetName: DisplayName,
      });
    }
  };

  const handleFormSubmit = (formData) => {
    setLoading(true);
    if (formData.type === 'add') {
      const newObj = { ...formData };
      delete newObj.type;
      apiServices
        .createPermissions(newObj)
        .then((response) => {
          if (response.status === 200) {
            setShow(false);
            setIsPermissionListRefreshed(true);
            setIsUnlistedPermissionListRefreshed(true);
            toast.success('Action Permission are created successfully', {
              position: 'top-right',
            });
          } else {
            const errorMessages = [];
            setShow(false);
            setLoading(false);
            for (const key in response.errors) {
              if (response.errors.hasOwnProperty(key)) {
                const messages = response.errors[key];
                errorMessages.push(...messages);
              }
            }
            errorMessages.forEach((errorMessage) => {
              toast.error(errorMessage, { position: 'top-right' });
            });
          }
        })
        .catch((error) => {
          setLoading(false);
          if (error.response && error.response.data && error.response.data.errors) {
            const errors = error.response.data.errors;
            // Extract HTTP status code

            // Loop through each error type (e.g., "EndDate") and display its messages
            Object.keys(errors).forEach((errorType) => {
              const errorMessages = errors[errorType];
              errorMessages.forEach((errorMessage) => {
                // Display each error message in the toaster
                toast.error(` ${errorMessage}`, {
                  position: 'top-right',
                });
              });
            });
          } else {
            // If there are no specific error messages, show a generic error
            toast.error(`${error.response.status} An unexpected error occurred`, {
              position: 'top-right',
            });
          }
        });
    } else {
      const newObj1 = { ...formData };
      apiServices
        .updatePermissions(newObj1)
        .then((response) => {
          if (response.status === 200) {
            setShow(false);
            setIsPermissionListRefreshed(true);
            setIsUnlistedPermissionListRefreshed(true);
            toast.success('Action Permission are updated successfully', {
              position: 'top-right',
            });
          } else {
            setShow(false);
            setLoading(false);
            const errorMessages = [];
            for (const key in response.errors) {
              if (response.errors.hasOwnProperty(key)) {
                const messages = response.errors[key];
                errorMessages.push(...messages);
              }
            }
            errorMessages.forEach((errorMessage) => {
              toast.error(errorMessage, { position: 'top-right' });
            });
          }
        })
        .catch((error) => {
          setLoading(false);

          if (error.response && error.response.data && error.response.data.errors) {
            const errors = error.response.data.errors;
            // Extract HTTP status code

            // Loop through each error type (e.g., "EndDate") and display its messages
            Object.keys(errors).forEach((errorType) => {
              const errorMessages = errors[errorType];
              errorMessages.forEach((errorMessage) => {
                // Display each error message in the toaster
                toast.error(` ${errorMessage}`, {
                  position: 'top-right',
                });
              });
            });
          } else {
            // If there are no specific error messages, show a generic error
            toast.error(`${error.response.status} An unexpected error occurred`, {
              position: 'top-right',
            });
          }
        });
    }
  };

  useEffect(() => {
    setLoading(true);
    apiServices
      .getPermissionList()
      .then((response) => {
        if (response.status === 200) {
          setPermissionList(response.data.permissionList);
          setIsGetPermissionList(false);
          setIsPermissionListRefreshed(false);
          setLoading(false);
        } else {
          // Handle other status codes here
          toast.error(`An unexpected error occurred: ${response.status}`, {
            position: 'top-right',
          });
          setLoading(false);
        }
      })
      .catch((error) => {
        // Handle errors
        console.error('Error uploading file:', error);
        setLoading(false);
      });
  }, [isGetPermissionList, isPermissionListRefreshed]);

  useEffect(() => {
    apiServices
      .getUnListedPermissions()
      .then((response) => {
        if (response.status === 200) {
          setUnListedPermissions(response.data.requestAndQueryNameList);
          setIsUnListedPermissions(false);
          setIsUnlistedPermissionListRefreshed(false);
        } else {
          // Handle other status codes here
          toast.error(`An unexpected error occurred: ${response.status}`, {
            position: 'top-right',
          });
        }
      })
      .catch((error) => {
        // Handle errors
        console.error('Error uploading file:', error);
      });
  }, [isGetUnListedPermissions, isUnlistedPermissionListRefreshed]);

  useEffect(() => {
    apiServices
      .getPermissionModuleList()
      .then((response) => {
        if (response.status === 200) {
          setPermissionModuleList(response.data.authReferenceLookups);
          setIsGetModuleList(false);
        } else {
          // Handle other status codes here
          toast.error(`An unexpected error occurred: ${response.status}`, {
            position: 'top-right',
          });
        }
      })
      .catch((error) => {
        // Handle errors
        console.error('Error uploading file:', error);
      });
  }, [isGetModuleList]);

  useEffect(() => {
    apiServices
      .getPermissionSetList()
      .then((response) => {
        if (response.status === 200) {
          setPermissionSetList(response.data.authReferenceLookups);
          setIsGetPermissionSetList(false);
        } else {
          // Handle other status codes here
          toast.error(`An unexpected error occurred: ${response.status}`, {
            position: 'top-right',
          });
        }
      })
      .catch((error) => {
        // Handle errors
        console.error('Error uploading file:', error);
      });
  }, [isGetPermissionSetList]);

  return (
    <>
      {loading && <Loader />}
      {/* <ToastContainer /> */}
      <div className="inner-page">
        <div className="dash-container">
          <div className="tbl_container">
            <div className="row">
              <div className="col-12 col-sm-12 col-md-12">
                <div className="main-hd">
                  <div className="pagetitle">
                    <img src="../assets/images/role-management-icons/left-arrow.png" alt="" />
                    Action Permission
                  </div>
                  <div className="third-div mobView">
                    <button className="add-btn" type="button" onClick={handleShowAdd}>
                      <img src={permission} alt="add-action-permission" />
                      Add Action Permission
                    </button>

                    {show && (
                      <div id="dropdown_modal">
                        <div className="modal show" tabIndex="-1" style={{ display: 'block' }}>
                          <div className="modal-dialog" style={{ maxWidth: '576px' }}>
                            <div className="modal-content">
                              <div className="modal-header">
                                <h5 className="modal-title">
                                  {isAddPermission
                                    ? 'Add Action Permission'
                                    : 'Edit Action Permission'}
                                </h5>
                                <div className="modalHdrRight">
                                  <button
                                    type="button"
                                    className="custom-btn-close"
                                    data-bs-dismiss="modal"
                                    aria-label="Close"
                                    onClick={handleClose}
                                  ></button>
                                </div>
                              </div>
                              <div className="modal-body" style={{ overflow: 'visible' }}>
                                {isAddPermission ? (
                                  <div className="pContent">
                                    <div className="permission-list">
                                      <label htmlFor="">Permission Name</label>
                                      <Dropdown
                                        onSelect={(eventKey, event) =>
                                          handlePermissionChange(
                                            eventKey,
                                            'permissionName',
                                            event.target.textContent
                                          )
                                        }
                                      >
                                        <Dropdown.Toggle variant="success" id="dropdown-basic">
                                          {formData.permissionDisplayName
                                            ? formData.permissionDisplayName
                                            : 'Select Permission'}
                                        </Dropdown.Toggle>

                                        <Dropdown.Menu>
                                          {unListedPermissions?.map((description) => (
                                            <Dropdown.Item
                                              key={description.value}
                                              eventKey={description.value}
                                            >
                                              {description.description}
                                            </Dropdown.Item>
                                          ))}
                                        </Dropdown.Menu>
                                      </Dropdown>
                                    </div>
                                    <div className="permission-list">
                                      <label htmlFor="">Permission Module</label>
                                      <Dropdown
                                        onSelect={(eventKey, event) =>
                                          handlePermissionChange(
                                            eventKey,
                                            'permissionModule',
                                            event.target.textContent
                                          )
                                        }
                                      >
                                        <Dropdown.Toggle variant="success" id="dropdown-basic">
                                          {formData.module ? formData.module : 'Select Module'}
                                        </Dropdown.Toggle>

                                        <Dropdown.Menu>
                                          {permissionModuleList?.map((permissionModule) => (
                                            <Dropdown.Item
                                              key={permissionModule.id}
                                              eventKey={permissionModule.id}
                                            >
                                              {permissionModule.displayName}
                                            </Dropdown.Item>
                                          ))}
                                        </Dropdown.Menu>
                                      </Dropdown>
                                    </div>
                                    <div className="permission-list">
                                      <label htmlFor="">Permission Set</label>
                                      <Dropdown
                                        onSelect={(eventKey, event) =>
                                          handlePermissionChange(
                                            eventKey,
                                            'permissionSet',
                                            event.target.textContent
                                          )
                                        }
                                      >
                                        <Dropdown.Toggle variant="success" id="dropdown-basic">
                                          {formData.permissionSetName
                                            ? formData.permissionSetName
                                            : 'Select Permission Set'}
                                        </Dropdown.Toggle>

                                        <Dropdown.Menu>
                                          {permissionSetList?.map((permissionSet) => (
                                            <Dropdown.Item
                                              key={permissionSet.id}
                                              eventKey={permissionSet.id}
                                            >
                                              {permissionSet.displayName}
                                            </Dropdown.Item>
                                          ))}
                                        </Dropdown.Menu>
                                      </Dropdown>
                                    </div>
                                  </div>
                                ) : (
                                  <div className="pContent">
                                    <div className="permission-name">
                                      <label htmlFor="">
                                        Permission Name: {formData?.permissionDisplayName}
                                      </label>
                                    </div>
                                    <div className="permission-list">
                                      <label htmlFor="">Permission Module</label>
                                      <Dropdown
                                        onSelect={(eventKey, event) =>
                                          handlePermissionChange(
                                            eventKey,
                                            'permissionModule',
                                            event.target.textContent
                                          )
                                        }
                                      >
                                        <Dropdown.Toggle variant="success" id="dropdown-basic">
                                          {formData.module ? formData.module : 'Select Module'}
                                        </Dropdown.Toggle>

                                        <Dropdown.Menu>
                                          {permissionModuleList?.map((permissionModule) => (
                                            <Dropdown.Item
                                              key={permissionModule.id}
                                              eventKey={permissionModule.id}
                                            >
                                              {permissionModule.displayName}
                                            </Dropdown.Item>
                                          ))}
                                        </Dropdown.Menu>
                                      </Dropdown>
                                    </div>
                                    <div className="permission-list">
                                      <label htmlFor="">Permission Group</label>
                                      <Dropdown
                                        onSelect={(eventKey, event) =>
                                          handlePermissionChange(
                                            eventKey,
                                            'permissionGroupName',
                                            event.target.textContent
                                          )
                                        }
                                      >
                                        <Dropdown.Toggle variant="success" id="dropdown-basic">
                                          {formData.permissionGroupId
                                            ? permissionGroupListSelected.find(
                                              (permissionGroup) =>
                                                permissionGroup.id === formData.permissionGroupId
                                            )?.permissionGroupDisplayName
                                            : 'Select Permission Group'}
                                        </Dropdown.Toggle>

                                        <Dropdown.Menu>
                                          {permissionGroupListSelected?.map((permissionGroup) => (
                                            <Dropdown.Item
                                              key={permissionGroup.id}
                                              eventKey={permissionGroup.id}
                                            >
                                              {permissionGroup.permissionGroupDisplayName}
                                            </Dropdown.Item>
                                          ))}
                                        </Dropdown.Menu>
                                      </Dropdown>
                                    </div>
                                    <div className="permission-list">
                                      <label htmlFor="">Permission Set</label>
                                      <Dropdown
                                        onSelect={(eventKey, event) =>
                                          handlePermissionChange(
                                            eventKey,
                                            'permissionSet',
                                            event.target.textContent
                                          )
                                        }
                                      >
                                        <Dropdown.Toggle variant="success" id="dropdown-basic">
                                          {formData.permissionSetName
                                            ? formData.permissionSetName
                                            : 'Select Permission Set'}
                                        </Dropdown.Toggle>

                                        <Dropdown.Menu>
                                          {permissionSetList?.map((permissionSet) => (
                                            <Dropdown.Item
                                              key={permissionSet.id}
                                              eventKey={permissionSet.id}
                                            >
                                              {permissionSet.displayName}
                                            </Dropdown.Item>
                                          ))}
                                        </Dropdown.Menu>
                                      </Dropdown>
                                    </div>
                                  </div>
                                )}
                              </div>
                              <div className="modal-footer">
                                <button className="btn btn-outline-primary" onClick={handleClose}>
                                  {' '}
                                  Cancel{' '}
                                </button>
                                <button
                                  className="btn btn-primary"
                                  onClick={() => handleFormSubmit(formData)}
                                  type="submit"
                                >
                                  Save
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>

                <div className="permission-table">
                  <table className="table  table-striped custom-table">
                    <thead>
                      <tr>
                        <th>Name</th>
                        <th>Module</th>
                        <th>Permission Set</th>
                      </tr>
                    </thead>

                    <tbody>
                      {permissionList?.map((permission) => (
                        <tr key={permission.permissionId}>
                          <td>{permission.permissionDisplayName}</td>
                          <td>{permission.moduleName}</td>
                          <td>{permission.permissionSetName}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ActionPermissionList;
